const dotsAlignmentData = ['start', 'end', 'center'];

export default dotsAlignmentData;
